/*
 * @Author: 刘枫
 * @Date: 2021-01-23 15:55:45
 * @Last Modified by: 刘枫
 * @title: 银牌网店列表
 * @Last Modified time: 2021-01-23 16:02:43
 */

<template>
  <div class="home-module mb">
    <div class="perStore clearfix" id="gtwdDiv" style="margin-top:40px;">
      <div v-for="store in list" class="perStore-item" :key="store.storeId">
        <router-link class="brand-img" :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}">
          <img :src="store.storeBanner" class="scrollLoading" />
        </router-link>

        <div class="perStore-info">
          <span class="brand-name">
            <router-link :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}">
              {{store.storeName}}
            </router-link>
          </span>
          <p class="brand-time">销售:{{store.totalBuyNum}}&nbsp;&nbsp;&nbsp;共{{store.totalGoodsNum}}商品</p>
        </div>
        <!-- 银牌个体 -->
        <!-- <span v-if="store.personal_store_type == '3000'" class="jpStore"></span> -->
      </div>
    </div>
    <div id="gtwdDivLoadding" v-if="loading">正在加载，请稍候 ...</div>
    <Alert v-if="!hasMore">没有更多数据</Alert>
  </div>
</template>
<script>
import { silverStoreListPage } from 'api/home';

export default {
  data() {
    return {
      list: [],
      pageNo: 1,
      pageSize: 20,
      hasMore: true,
      loading: false,
      hasBoundScroll: false
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.bindScroll();
  },
  destroyed() {
    $(window).unbind("scroll");
  },
  activated() {
    this.bindScroll();
  },
  deactivated() {
    $(window).unbind("scroll");
    this.hasBoundScroll = false;
  },
  methods: {
    fetchData(pageSize = 8) {
      let data = {
        storeType: 5,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }
      if (this.hasMore && !this.loading) {
        this.loading = true;
        silverStoreListPage(data).then(json => {
          if (json.resCode == 1) {
            this.loading = false;
            let data = json.data;
            this.hasMore = data.hasMore;
            if (this.hasMore) {
              this.pageNo = this.pageNo + 1;
            }
            let storeList = data.list || [];
            let temp = this.list;
            this.list = temp.concat(storeList);
          }
        });
      }
    },
    bindScroll() {
      //防止重复绑定
      let _this = this;
      if (!this.hasBoundScroll) {
        $(window).scroll(function (e) {
          var scrollTop = $(this).scrollTop();
          var scrollHeight = $(document).height();
          var windowHeight = $(window).height();
          if (scrollTop + windowHeight + 430 >= scrollHeight && _this.hasMore && !_this.loading) {
            _this.fetchData();
          }
        });
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// good-shop.vue?6a505764